export default "__VITE_ASSET__CUj1XEYA__"